export const hasNoActiveClassroomsMessage =
  "There are no active classrooms available. You can add new classes or sync classes from your LMS in class directory.";
export const hasNoStudentsInClassroomMessage =
  "This classroom has no students. You can add students to your Newsela class or sync classes from your LMS in class directory.";
export const emptyStateDefaultMessage =
  "Create an assignment for your students or encourage them to read independently and view their progress on this page.";
export const emptyStateButtonText = "Go to class directory";
export const emptyStateButtonHref = "/account/classes/";
